module.exports = __webpack_public_path__ + "static/media/logoWhite.047950b6.png";